import { render, staticRenderFns } from "./QLeadAllocationReviewDataTable.vue?vue&type=template&id=56413d87&scoped=true&"
import script from "./QLeadAllocationReviewDataTable.vue?vue&type=script&lang=js&"
export * from "./QLeadAllocationReviewDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QLeadAllocationReviewDataTable.vue?vue&type=style&index=0&id=56413d87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56413d87",
  null
  
)

export default component.exports